import { render } from "./EditTokenType.vue?vue&type=template&id=6a8d8384&ts=true"
import script from "./EditTokenType.vue?vue&type=script&lang=ts"
export * from "./EditTokenType.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__